import React, { useState, useEffect } from 'react';
import { useParams} from 'react-router-dom';
import Overview from '../../components/client/Overview';
import InfoClient from '../../components/client/InfoClient';
import Billing from '../../components/client/Billing';
import clientService from '../../services/ClientService';

export default function ClientDetail({ itemsPerPage = 10 }) {
    const { id } = useParams();
    const [client, setClient] = useState(null);
    const [activeTab, setActiveTab] = useState('overview');

    const fetchClient= async (id) => {
        try {
            const res = await clientService.getClient(id);
            setClient(res.data);
        } catch (error) {
            console.error('Error fetching client', error);
        }
    }
    useEffect(() => {
        fetchClient(id);
    }, [id]);  // Ricarica i dati quando l'ID cambia

    if (!client) {
        return <p>Caricamento...</p>;
    }
    // Funzione per gestire il click sui tab
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

  	return (
        <>
            <div className="row">
                {/* Detail Sidebar */}
                <div className="col-xl-4 col-lg-5 col-md-5 order-1 order-md-0">
                    <div className="card mb-6">
                        <div className="card-body pt-12">
                            <div className="customer-avatar-section">
                                <div className="d-flex align-items-center flex-column">
                                    <div className="avatar">
                                        <div className="avatar-initial rounded bg-label-primary">
                                            <i className="bx bx-store bx-lg"></i>
                                        </div>
                                    </div>
                                    <div className="customer-info text-center mb-6">
                                        <h5 className="mb-0">{client.fullname}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="info-container">
                                <h5 className="pb-4 border-bottom text-capitalize mt-6 mb-4">Dettaglio</h5>
                                <ul className="list-unstyled mb-6">
                                    <li className="mb-2">
                                        <span className="h6 me-1">Indirizzo:</span>
                                        <span>{client.indirizzo_sede ? client.indirizzo_sede : 'Non inserito'}</span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="h6 me-1">Comune:</span>
                                        <span>{client.comune ? client.comune : 'Non inserito'} {client.provincia ? '- ('+ client.provincia +')' : ''}</span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="h6 me-1">Cap:</span>
                                        <span>{client.cap ? client.cap : 'Non inserito'}</span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="h6 me-1">Nazione:</span>
                                        <span>{client.nazione ? client.nazione : 'Non inserita'}</span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="h6 me-1">Stato:</span>
                                        <span className={`badge me-1 ${client.status ? "bg-label-success" : "bg-label-danger"}`}>
                                            {client.status ? 'Attivo': 'Non Attivo'}
                                        </span>
                                    </li>
                                </ul>
                                <div className="d-flex justify-content-center">
                                    <a  className="btn btn-primary me-4">Modifica</a>
                                    {client.status && <a  className="btn btn-label-danger">Sospendi</a>}
                                    {!client.status && <a className="btn btn-label-success">Attiva</a>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /Detail Sidebar */}
                <div className="col-xl-8 col-lg-7 col-md-7 order-0 order-md-1">
                    {/* Nav ClientDetail */}
                    <div className="nav-align-top">
                        <ul className="nav nav-pills flex-column flex-md-row mb-6">
                            <li className="nav-item">
                                <a onClick={() => handleTabClick('overview')}
                                    className={`nav-link ${activeTab === 'overview' ? 'active' : ''}`}>
                                    <i className="bx bx-sm bx-user me-1_5"></i>
                                    Panoramica
                                </a>
                            </li>
                            <li className="nav-item">
                                <a onClick={() => handleTabClick('info')}
                                    className={`nav-link ${activeTab === 'info' ? 'active' : ''}`}>
                                    <i className="bx bx-info-circle me-1_5 bx-md"></i>
                                    Informazioni
                                </a>
                            </li>
                            <li className="nav-item">
                                <a onClick={() => handleTabClick('billing')}
                                    className={`nav-link ${activeTab === 'billing' ? 'active' : ''}`}>
                                    <i className="bx bx-detail me-1_5 bx-sm"></i>
                                    Fatturazione
                                </a>
                            </li>
                        </ul>
                    </div>
                    {/* /Nav ClientDetail */}
                    {/* Customer cards  */}
                    {activeTab === 'overview' && <Overview client={client} />}
                    {activeTab === 'info' && <InfoClient client={client} />}
                    {activeTab === 'billing' && <Billing client={client} />}
                    {/* /Customer cards  */}
                </div>
            </div>
        </>
	);
}